import { useEffect, useRef, useState } from "react";

export function useReveal() {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !ref.current || !("IntersectionObserver" in window)) {
      setStarted(true);
      return;
    }

    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setStarted(true);
        observer.disconnect();
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, started];
}

export function riseClass(started) {
  return `transition duration-700 ease-out motion-reduce:translate-y-0 motion-reduce:opacity-100 motion-reduce:transition-none ${
    started ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
  }`;
}

export function riseDelay(started, delay) {
  return started ? { transitionDelay: `${delay}ms` } : undefined;
}
